import { render, staticRenderFns } from "./peopleList.vue?vue&type=template&id=c9e28486&scoped=true"
import script from "./peopleList.vue?vue&type=script&lang=js"
export * from "./peopleList.vue?vue&type=script&lang=js"
import style0 from "./peopleList.vue?vue&type=style&index=0&id=c9e28486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e28486",
  null
  
)

export default component.exports